import { lengthPercentageDataToString } from "./length-percentage";
function borderRadiusPropertyDataToStyle(data, defaultValue = {}) {
  const borderTopLeftRadius = data.borderTopLeftRadius ?? defaultValue.borderTopLeftRadius;
  const borderTopRightRadius = data.borderTopRightRadius ?? defaultValue.borderTopRightRadius;
  const borderBottomRightRadius = data.borderBottomRightRadius ?? defaultValue.borderBottomRightRadius;
  const borderBottomLeftRadius = data.borderBottomLeftRadius ?? defaultValue.borderBottomLeftRadius;
  const style = {};
  if (borderTopLeftRadius != null) {
    style.borderTopLeftRadius = lengthPercentageDataToString(borderTopLeftRadius);
  }
  if (borderTopRightRadius != null) {
    style.borderTopRightRadius = lengthPercentageDataToString(borderTopRightRadius);
  }
  if (borderBottomRightRadius != null) {
    style.borderBottomRightRadius = lengthPercentageDataToString(borderBottomRightRadius);
  }
  if (borderBottomLeftRadius != null) {
    style.borderBottomLeftRadius = lengthPercentageDataToString(borderBottomLeftRadius);
  }
  return style;
}
export {
  borderRadiusPropertyDataToStyle
};
//# sourceMappingURL=border-radius.js.map